import { ESDialogTitle } from '@energy-stacks/core/ui';
import { Dialog, IconButton, useTheme } from '@mui/material';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  ConfirmCloseDialog,
  useConfirmCloseDialog,
} from '@energy-stacks/shared';
import { brokerAddChargingStationSteps } from './brokerAddChargingStationSteps';
import { resetStepper, useAppSelector } from '@energy-stacks/store';
import { BrokerAddChargingStationForm } from './BrokerAddChargingStationForm';
import { IconX } from '@tabler/icons-react';

export const BrokerAddChargingStation = () => {
  const dispatch = useDispatch();
  const [isDialogOpen, setIsDialogOpen] = useState(true);
  const [t] = useTranslation('chargingStations');
  const activeStep = useAppSelector((state) => state.stepper.stepperActiveStep);
  const [isFormDirty, setIsFormDirty] = useState(false);
  const { palette } = useTheme();

  useEffect(() => {
    return () => {
      dispatch(resetStepper());
    };
  }, [dispatch]);

  const {
    isConfirmCloseDialogOpen,
    handleOpenConfirmDialog,
    handleStay,
    handleLeaveWithoutSaving,
  } = useConfirmCloseDialog(isFormDirty);

  return (
    <>
      <Dialog
        open={isDialogOpen}
        onClose={handleOpenConfirmDialog}
        maxWidth="lg"
        fullWidth
      >
        <ESDialogTitle
          data-testid="addStationDialogTitle"
          sx={{
            borderBottom: `1px solid ${palette.grey[300]}`,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 4,
          }}
          justifyContent="space-between"
        >
          {t('addChargingStation')}
          <IconButton
            data-testid="addStationCloseModalButton"
            onClick={handleOpenConfirmDialog}
          >
            <IconX />
          </IconButton>
        </ESDialogTitle>
        <BrokerAddChargingStationForm
          display={brokerAddChargingStationSteps[activeStep].name}
          onSetIsDialogOpen={setIsDialogOpen}
          activeStep={activeStep}
          onFormDirty={setIsFormDirty}
        />
      </Dialog>
      <ConfirmCloseDialog
        open={isConfirmCloseDialogOpen}
        onStay={handleStay}
        onLeaveWithoutSaving={handleLeaveWithoutSaving}
        testId="addStation"
      />
    </>
  );
};
